'use client';

import type { Locale } from '@core/Entities/Locale/Locale.entity';
import Button from '@gds/Button/Button';
import { ChevronRight } from '@gds/Icons';
import { useModal } from '@modal/Hooks/UseModal';

import { CampaignPromotionModal } from '../CampaignPromotionModal/CampaignPromotionModal';

import styles from './CampaignPromotionCta.module.css';

interface CampaignPromotionCtaProps {
  campaignData: Record<string, any>;
  locale: Locale;
}

const CampaignPromotionCta = ({ campaignData, locale }: CampaignPromotionCtaProps) => {
  const { openModal } = useModal();

  return (
    <div className={styles.campaignPromotionModal}>
      <Button
        color="mint"
        rightIcon={<ChevronRight />}
        onClick={() =>
          openModal(
            <CampaignPromotionModal
              campaignData={campaignData}
              locale={locale}
            ></CampaignPromotionModal>,
            {
              header: campaignData?.headline?.value,
            },
          )
        }
        fullWidth
      >
        {campaignData?.cta_label?.value}
      </Button>
    </div>
  );
};

export default CampaignPromotionCta;
